module.exports = __webpack_public_path__ + "img/credits.369949c3.png";